import { render, staticRenderFns } from "./EmployersLandingPage.vue?vue&type=template&id=71db77bd&scoped=true"
import script from "./EmployersLandingPage.vue?vue&type=script&lang=js"
export * from "./EmployersLandingPage.vue?vue&type=script&lang=js"
import style0 from "./EmployersLandingPage.vue?vue&type=style&index=0&id=71db77bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db77bd",
  null
  
)

export default component.exports